module.exports = __webpack_public_path__ + "static/profile-8a5f72534c47e84afc6ef6a9e307fdd2.jpg";